import React from 'react';
import { useAwoContext } from '../AwoContextProvider';
import MembersPanel from '../Organizations/MembersPanel';

function MembersContent() {
  const { awo } = useAwoContext();
  return <MembersPanel awo={awo} />;
}

export default MembersContent;
